// client/src/routes/app/utilities/$serviceId/readings.new.tsx — SCR-UTIL-002 „Citire contor
// nouă" · MAINT-008 (04 §8.8; the file path and the URL are 04 §7's tree and §8.8's table,
// which agree: `readings.new.tsx` under `$serviceId/` is `/app/utilities/$serviceId/readings/new`).
//
// A ROUTE OF ITS OWN rather than a dialog on the detail, unlike the registry form: 04 §8.8
// gives this screen an ID and a URL, and 04 §11.2's flow P4 wants it reachable in one tap from
// a list row on a phone — a modal cannot be a deep link and a modal on a detail screen means
// loading the detail's chart first.
//
// THE SCREEN FETCHES THE SERVICE, not the last reading. `UtilityServiceDetail.nextPreviousValue`
// is the index this submission will be measured against — the server's own number (D-970) — and
// `measurementUnit` is the string every figure on the form is spelled in. One request, and the
// form is complete.
//
// GATED ON `Operations.Write`, not `Operations.Read`: this screen has nothing to look at. The
// `accountant` role, which holds neither, renders SCR-SYS-403 (§9.2.2). The PHOTOGRAPH is
// gated separately on `Documents.Write` inside the form, because a role could hold one and not
// the other and a reading without a picture is still a reading.

import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { PageHeader } from '@/components/layout/PageHeader';
import { RequirePermission } from '@/components/layout/route-guards';
import { ErrorState, LoadingState } from '@/components/ui/states';
import { ReadingForm } from '@/features/utilities/ReadingForm';
import { useUtilityService } from '@/features/utilities/queries';

export const Route = createFileRoute('/app/utilities/$serviceId/readings/new')({
  component: NewReadingScreen,
});

function NewReadingScreen() {
  const { serviceId } = Route.useParams();
  const { t } = useTranslation();
  const service = useUtilityService(serviceId);

  if (service.isPending) return <LoadingState rows={3} />;
  if (service.isError) {
    return <ErrorState error={service.error} onRetry={() => void service.refetch()} />;
  }

  const detail = service.data;

  return (
    <RequirePermission permission="Operations.Write">
      <PageHeader
        title={t('utilities.reading.title')}
        description={`${t(`enums.UtilityType.${detail.utilityType}`)} · ${detail.propertyName}`}
        backTo="/app/utilities"
        backLabel={t('utilities.detail.backToList')}
      />
      <ReadingForm service={detail} />
    </RequirePermission>
  );
}
